var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-list-container"},[_c('ul',_vm._l((_vm.data),function(item){return _c('li',{key:item.knowledge_code,class:_vm.value === item.knowledge_code ? 'is-active': '',on:{"click":function($event){return _vm.onItemClick(item)}}},[_vm._v(_vm._s(item.knowledge_name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }